import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";

import {ValidateStep3Data} from "@validators/motor-cycle-insurance-form/step3-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import {
    MOTOR_CYCLE_KEEPER_OPTIONS,
    MOTOR_CYCLE_OWNER_OPTIONS,
    MOTOR_CYCLE_PARKING_OPTIONS
} from "@constants/dropdown-choices";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";

export default function IF_Step3({data, handlers, setCurrentStep}) {

    const onPrevBtnClick = (event) => {
        setCurrentStep(2);
    }

    const onNextBtnClick = (event) => {

        let validationResult = ValidateStep3Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult : validationResult
            });


        } else {
            setCurrentStep(4);
        }


    }

    return (
        <div className='if-step-3'>

            <SectionHeading
                text="Bike details"
            />


            <div className="row">

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3"
                    labelText="Bike registration number"
                    required={true}
                    controlName="bikeRegNumber"
                    value={data.bikeRegNumber}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Manufacturer */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Manufacturer"
                    required={true}
                    controlName="bikeManufacturer"
                    value={data.bikeManufacturer}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Model */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Model"
                    required={true}
                    controlName="bikeModel"
                    value={data.bikeModel}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Year */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Year"
                    required={true}
                    controlName="bikeYear"
                    value={data.bikeYear}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            </div>

            <div className="row">

                {/* Is the bike fitted with a sidecar? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Is the bike fitted with a sidecar?"
                    required={true}
                    controlName="isFittedWithSideCar"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isFittedWithSideCar}
                    onChange={handlers.onControlChange}
                />

                {/* Is the bike imported? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Is the bike imported?"
                    required={true}
                    controlName="isImported"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isImported}
                    onChange={handlers.onControlChange}
                />



            </div>

            <div className="row">
                {/* Does this bike have any modifications? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Does this bike have any modifications?"
                    required={true}
                    controlName="hasModifications"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasModifications}
                    onChange={handlers.onControlChange}
                />

                {/* Are there any security devices fitted to this bike? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Are there any security devices fitted to this bike?"
                    required={true}
                    controlName="hasSecurityDeviceFitted"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasSecurityDeviceFitted}
                    onChange={handlers.onControlChange}
                />

            </div>

            <div className="row">
                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3"
                    labelText="What is the current market value of this bike?"
                    required={true}
                    controlName="bikeMarketValue"
                    value={data.bikeMarketValue}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />
            </div>

            <SectionHeading
                text="Using this bike"
            />

            <div className="row">

                {/* Purchase date of the bike */}

                <ScrollableCustomDateTimePickerBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Purchase date of the bike"
                    required={true}
                    controlName="bikePurchaseDate"
                    value={data.bikePurchaseDate}
                    onChange={handlers.onControlChange}
                />


                {/* Registration date of the bike */}

                <ScrollableCustomDateTimePickerBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Registration date of the bike"
                    required={true}
                    controlName="bikeRegistrationDate"
                    value={data.bikeRegistrationDate}
                    onChange={handlers.onControlChange}
                />

            </div>

            <div className="row">
                {/* Who is the registered owner of this bike? */}

                <ScrollableDropdownBlock
                    controlName="registeredOwner"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Who is the registered owner of this bike?"
                    required={true}
                    options={MOTOR_CYCLE_OWNER_OPTIONS}
                    selectedValues={data.registeredOwner}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Who is the registered keeper of this bike? */}

                <ScrollableDropdownBlock
                    controlName="registeredKeeper"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Who is the registered keeper of this bike?"
                    required={true}
                    options={MOTOR_CYCLE_KEEPER_OPTIONS}
                    selectedValues={data.registeredKeeper}
                    onChange={handlers.onControlChange}
                    helpText=""
                />
            </div>

            <div className="row">
                {/* Where is this bike kept whilst at home address? */}

                <ScrollableDropdownBlock
                    controlName="bikeParkingAtHomeAddress"
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Where is this bike kept whilst at home address?"
                    required={true}
                    options={MOTOR_CYCLE_PARKING_OPTIONS}
                    selectedValues={data.bikeParkingAtHomeAddress}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Is this bike kept at your address overnight? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Is this bike kept at your address overnight?"
                    required={true}
                    controlName="isBikeKeptOvernight"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isBikeKeptOvernight}
                    onChange={handlers.onControlChange}
                />

            </div>

            <div className="row">
                {/* What is this bike's current mileage? */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Current mileage"
                    required={true}
                    controlName="currentMileage"
                    value={data.currentMileage}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* What is this bike's annual mileage? */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Annual mileage"
                    required={true}
                    controlName="annualMileage"
                    value={data.annualMileage}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* What is this bike's annual business mileage? */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Annual business mileage"
                    required={true}
                    controlName="annualBusinessMileage"
                    value={data.annualBusinessMileage}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            </div>

            <div className="row">

                {/* Will pillion passengers be carried? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Will pillion passengers be carried?"
                    required={true}
                    controlName="willCarryPillionPassengers"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.willCarryPillionPassengers}
                    onChange={handlers.onControlChange}
                />

                {/* Will the bike be used for towing? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="Will the bike be used for towing?"
                    required={true}
                    controlName="willBeUsedForToeing"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.willBeUsedForToeing}
                    onChange={handlers.onControlChange}
                />

            </div>
           
           <WizardStepButtonsBlock
              onNextBtnClick={onNextBtnClick}
              onPrevBtnClick={onPrevBtnClick}
              nextButtonAdditionalCssClass={``}
           />
           
        </div>
    );

}